// extracted by mini-css-extract-plugin
module.exports = {"bioContainer":"AthleteBio_bioContainer__r9j0R","personalData":"AthleteBio_personalData__6mzsG"};